<nav aria-label="breadcrumb" *ngIf="idMarket">
  <a [routerLink]="['/documents']">Accueil</a> <mat-icon>arrow_right</mat-icon> <span>Édition d'un marché</span>
</nav>

<nav aria-label="breadcrumb" *ngIf="!idMarket">
  <a [routerLink]="['/documents']">Accueil</a> <mat-icon>arrow_right</mat-icon> <span>Création d'un marché</span>
</nav>

<mat-card>
  <mat-label>Nom*</mat-label>
  <mat-form-field class="nom-market">
    <input class="nom-market" matInput [(ngModel)]="market.name" maxlength="100">
  </mat-form-field>

  <mat-divider></mat-divider>
  <mat-label>Icône*</mat-label>
  <mat-card-content fxLayout="row">
    <div *ngFor="let img of listImg">
      <img [ngClass]="imgSelected === img ? 'selected' : ''" (click)="selectedIcon(img)" src="assets/icons/{{img}}" alt="homepage" width="60" height="60">
    </div>
  </mat-card-content>
  
  <mat-divider></mat-divider>
  <mat-card-footer fxLayout="row" fxLayoutAlign="end">
    <button mat-raised-button color="primary" [ngClass]="!market.name || !market.icon ? '' : 'primary-button'" (click)="updateMarket()" aria-label="Enregistrer" 
    [disabled]="!market.name || !market.icon">Enregistrer</button>
  </mat-card-footer>
</mat-card>
  
